import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { LogService } from '@services/log.service';
import { environment } from '@environments/environment';
import { buildInfo } from '@environments/build-info';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  version = environment.appVersion;
  buildDate = new Date(buildInfo.buildDate).toLocaleString('en-GB', {timeZone: 'Europe/London'});

  constructor(private logService: LogService) {}

  ngOnInit(): void {
    // Log page view
    this.logService.logPageView('about', {});
  }
  
  whatsNew = [
    'Digital signature now opens in an inline iframe popup — no more navigating to a new tab',
  ];
  
  knownIssues = [
    'Data synchronization may take up to 24 hours'
  ];
}
